export default __webpack_public_path__ + "static/media/Icon_3.4205ed39.png";